import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";

export class InfoPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, introTextValue: string, bodyTextValue: string, callback: () => unknown,
                okText: string = Tr('horosho')) {
        super(scene, canvas, title);

        let introText = TextUtils.addTextByFamily(scene, introTextValue, 0, -140,
            '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);

        let bodyText = TextUtils.addTextAdvanced(scene, bodyTextValue, 0, -40,
            '#a2ff82', 14, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        this.add([introText, bodyText]);

        this.setOnCLoseCallback(callback);
        this.addCloseButton(okText, () => {});
    }

}
